/*
 * @Description: 智能助手
 * @Author: sizhanhe
 * @Date: 2024-05-08 14:35:28
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-05-11 16:21:04
 */
import { get } from '@/utils/request'

export * from './file'
export * from './material'
export * from './session'

/**
 * 获取剩余默认次数
 * @param enterpriseId number
 * @returns totalFreeTimes: 每日总免费次数; usedTimes: 每日已使用次数
 */
export function getQaDailyLimit<T>(data: { enterpriseId: number }) {
  return get<T>({
    url: '/assistant/permission/settings/qaDailyLimit',
    data,
  })
}
